var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-wrapper"},[_c('img',{attrs:{"src":"https://files.jinr.com/jinr-index/img/bank-content-01.png","alt":"","srcset":""}}),_c('img',{attrs:{"src":"https://files.jinr.com/jinr-index/img/bank-content-02.png","alt":"","srcset":""}})])
}]

export { render, staticRenderFns }